/* eslint-disable camelcase */
import { privateFetcher } from 'services/appFetcher.services';
import ENDPOINTS from 'constants/endpoints.constants';
import { ErrorCodes } from 'constants/errors.constants';
import APIError from 'exceptions/APIError';

export interface PudoLocationParams {
  postal_code: string;
  country_code: string;
  organization_slug: string;
}

export const getReturnDropOffLocations = async (
  orgId: number,
  params: PudoLocationParams,
): Promise<{ data: any[] }> => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v2/ptp/collection-points/${orgId}/`;
    const { data } = await privateFetcher.get(url, { params });
    return data;
  } catch (error) {
    if (error.response) {
      throw new APIError('RETURN_TRY_DIFFERENT_POSTAL_CODE');
    }

    throw error;
  }
};
